import { useParams } from "react-router-dom";
import { useMemo } from "react";

// import components

import "./ShipmentQuotesV2.scss";
import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";
import { useGetQuickRequestDetails } from "api/queries/quick-request/useGetQuickRequestDetails";
import QuotationDetailDrawer from "pages/common/ShipmentQuotesV2/components/QuotationDetailDrawer/QuotationDetailDrawer";
import usePermissions from "hooks/usePermissions";
import Header from "./components/Header/Header";
import QuotesTable from "./components/QuotesTable/QuotesTable";
import InvitedProviders from "./components/InvitedProviders/InvitedProviders";
import ApprovalFlow from "./components/ApprovalFlow/ApprovalFlow";
import Comments from "./components/Comments/Comments";
import ShipperCustomLongfield from "./components/ShipperCustomLongfield/ShipperCustomLongfield";

function ShipmentQuotesV2({ isQuickRequest, setIsConsolidated }: { isQuickRequest?: boolean; setIsConsolidated: any }) {
  const { id: paramId } = useParams();
  const id = paramId ? paramId.toUpperCase() : "";
  const { permissions } = usePermissions();

  const parsedPermissions = JSON.parse(permissions || "{}");
  const view_quote_pricing = parsedPermissions?.permissions?.booking?.view_quote_pricing;

  const { isInitialLoading: quoteDetailLoading, data: quoteDetailsData } = useGetQuoteRequestDetails({
    shipmentId: id,
    options: {
      enabled: !isQuickRequest,
    },
  });

  const { isInitialLoading: quickDetailLoading, data: quickDetailsData } = useGetQuickRequestDetails(id, {
    enabled: isQuickRequest,
    refetchOnMount: false,
  });

  const data = useMemo(
    () => (isQuickRequest ? quickDetailsData : quoteDetailsData) || {},
    [isQuickRequest, quickDetailsData, quoteDetailsData],
  );

  const loadingData = isQuickRequest ? quickDetailLoading : quoteDetailLoading;
  const customLongfield = data?.organization?.custom_longfield_01 || data?.organization?.custom_longfield1;

  return (
    <div className="shipper-shipment-quotes">
      <Header
        isQuickRequest={!!isQuickRequest}
        data={data}
        loadingData={loadingData}
        fetchData={isQuickRequest ? useGetQuickRequestDetails : useGetQuoteRequestDetails}
        setIsConsolidated={setIsConsolidated}
      />

      <div className={`shipment-quotes-container ${isQuickRequest ? "" : "mt-3xl"}`}>
        <div className="main-content">
          {!isQuickRequest && <QuotesTable />}
          <Comments isQuickRequest={isQuickRequest} />
        </div>
        <div className="sidebar-content">
          {!isQuickRequest && (
            <>
              {view_quote_pricing && <ApprovalFlow />}
              <InvitedProviders />
            </>
          )}
          {customLongfield && <ShipperCustomLongfield customLongfield={customLongfield} />}
        </div>
      </div>
      <QuotationDetailDrawer />
    </div>
  );
}

export default ShipmentQuotesV2;

ShipmentQuotesV2.defaultProps = {
  isQuickRequest: false,
};
